import { APPEND_WOLT_RESTAURANTS, SET_SHOW_WOLT_RESTAURANT_DATA_MODAL, SET_WOLT_RESTAURANT, SET_WOLT_RESTAURANT_INTEGRATION_CODE, SET_WOLT_RESTAURANT_INTEGRATION_LINK_IS_CREATING, SET_WOLT_RESTAURANT_SHOW_CREATE_INTEGRATION_MODAL, SET_WOLT_RESTAURANT_SHOW_ERROR_INTEGRATION_MESSAGE, SET_WOLT_RESTAURANT_SHOW_SUCCESS_INTEGRATION_MESSAGE, SET_WOLT_RESTAURANTS, SET_WOLT_RESTAURANTS_SHOW_ERROR_MODAL, SET_WOLT_RESTAURANTS_TOTAL_LENGTH } from '../../actionTypes/woltRestaurant'

const initialState = {
	restaurants: [],
	restaurantsTotalLength: 0,
	restaurant: null,
	showErrorModal: false,
	integrationLinkIsCreating: false,
	integrationCode: null,
	showCreateIntegrationModal: false,
	showRestaurantDataModal: false,
	showSuccessIntegrationMessage: false,
	showErrorIntegrationMessage: false,
}

export function woltRestaurantReducer (state = initialState, action) {
	switch (action.type) {
		case SET_WOLT_RESTAURANTS:
			return {
				...state,
				restaurants: action.value,
			}
		case SET_WOLT_RESTAURANTS_TOTAL_LENGTH:
			return {
				...state,
				restaurantsTotalLength: action.value,
			}
		case SET_WOLT_RESTAURANT:
			return {
				...state,
				restaurant: action.value,
			}
		case APPEND_WOLT_RESTAURANTS:
			return {
				...state,
				restaurants: state.restaurants ? state.restaurants.concat(...action.value) : action.value,
			}
		case SET_WOLT_RESTAURANTS_SHOW_ERROR_MODAL:
			return {
				...state,
				showErrorModal: action.value,
			}
		case SET_WOLT_RESTAURANT_INTEGRATION_LINK_IS_CREATING:
			return {
				...state,
				integrationLinkIsCreating: action.value,
			}
		case SET_WOLT_RESTAURANT_INTEGRATION_CODE:
			return {
				...state,
				integrationCode: action.value,
			}
		case SET_WOLT_RESTAURANT_SHOW_CREATE_INTEGRATION_MODAL:
			return {
				...state,
				showCreateIntegrationModal: action.value,
			}
		case SET_SHOW_WOLT_RESTAURANT_DATA_MODAL:
			return {
				...state,
				showRestaurantDataModal: action.value,
			}
		case SET_WOLT_RESTAURANT_SHOW_SUCCESS_INTEGRATION_MESSAGE:
			return {
				...state,
				showSuccessIntegrationMessage: action.value,
			}
		case SET_WOLT_RESTAURANT_SHOW_ERROR_INTEGRATION_MESSAGE:
			return {
				...state,
				showErrorIntegrationMessage: action.value,
			}
		default:
			return state
	}
}
